import { Vue, Component } from "vue-property-decorator";
import { onProduction } from "./onProduction";

/**
 * 本番環境かどうか判定するためのmixin
 */
@Component({})
export class EnvironmentMixin extends Vue {
  onProduction = onProduction;
}
